export const ONBOARDING_FOLDER_MEMORY_VERSION = 1;
export const ONBOARDING_FOLDER_MEMORY_KEY_PREFIX = 'segmently.onboardings.currentFolder.v1';

export interface OnboardingFolderMemory {
  version: typeof ONBOARDING_FOLDER_MEMORY_VERSION;
  folderId: string | null;
}

export function getOnboardingFolderMemoryKey(projectId: string): string {
  return `${ONBOARDING_FOLDER_MEMORY_KEY_PREFIX}.${projectId}`;
}

export function readOnboardingFolderMemory(projectId: string): OnboardingFolderMemory {
  if (typeof window === 'undefined') {
    return createOnboardingFolderMemory(null);
  }

  try {
    const rawValue = window.localStorage.getItem(getOnboardingFolderMemoryKey(projectId));
    if (!rawValue) {
      return createOnboardingFolderMemory(null);
    }

    const parsed = JSON.parse(rawValue) as Partial<OnboardingFolderMemory>;
    if (
      parsed.version !== ONBOARDING_FOLDER_MEMORY_VERSION ||
      !('folderId' in parsed) ||
      (parsed.folderId !== null && typeof parsed.folderId !== 'string')
    ) {
      writeOnboardingFolderMemory(projectId, null);
      return createOnboardingFolderMemory(null);
    }

    return createOnboardingFolderMemory(parsed.folderId);
  } catch {
    writeOnboardingFolderMemory(projectId, null);
    return createOnboardingFolderMemory(null);
  }
}

export function writeOnboardingFolderMemory(projectId: string, folderId: string | null): void {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    window.localStorage.setItem(
      getOnboardingFolderMemoryKey(projectId),
      JSON.stringify(createOnboardingFolderMemory(folderId)),
    );
  } catch {
    // Storage can be unavailable in private browsing or test sandboxes.
  }
}

function createOnboardingFolderMemory(folderId: string | null): OnboardingFolderMemory {
  return {
    version: ONBOARDING_FOLDER_MEMORY_VERSION,
    folderId,
  };
}
